import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiPublishArticleRequestBody,
  IApiPublishArticleResponseBody,
} from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';
import { articleQueryKeyFactory } from './useArticleQuery';

export type IUsePublishArticleMutationValues = {
  appId: string;
  articleId: string;
  body: IApiPublishArticleRequestBody;
};

export const usePublishArticleMutation = (): UseMutationResult<
  IApiPublishArticleResponseBody,
  unknown,
  IUsePublishArticleMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUsePublishArticleMutationValues) =>
      api.articles.publish(values.appId, values.articleId, values.body),
    onSuccess: async (publishedArticle, values) => {
      // // TODO once the API is updated to return the published article object
      // await Promise.all(
      //   (publishedArticle.categoriesId ?? [])
      //     .map((categoryId) => ({
      //       queryKey: articlesQueryKeyFactory({
      //         appId: values.appId,
      //         categoryId,
      //       }),
      //     }))
      //     .map((filters) => queryClient.invalidateQueries(filters)),
      // );

      // In the meantime:
      await queryClient.invalidateQueries({
        queryKey: articleQueryKeyFactory({
          appId: values.appId,
          articleId: publishedArticle.results.articleId,
        }),
      });
    },
  });
};
